import React from 'react';
import { ArrowRightIcon, MessageSquareTextIcon, RefreshCwIcon } from 'lucide-react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { heroOct, introPoll } from '../../../data/teaser';
import { campaignStages, deckMeta, nextSteps, reuseBlocks } from '../../../data/deck';
export function CampaignSlide() {
  return <Slide id="campaign" data-id="element-47" data-mp="1gj67nnylghk0">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-16" data-id="element-48" data-mp="1gjofziyj6m8a">
        <InView data-id="element-49" data-mp="1biijda1r2eth">
          <SlideHeadline lead="When a market needs more than an asset —" follow="we can help run the campaign." size="medium" data-id="element-50" data-mp="1bhyzvowgbidc" />
        </InView>
        <InView delay={0.06} data-id="element-51" data-mp="12k6vhfs9pv4q">
          <p className="text-[14.5px] leading-[1.7] text-navy/65" data-id="element-52" data-mp="12kyhbyw2ceht">
            An end-to-end, always-on rhythm: a hook brings specialists in, a Snak engages them, and every answer
            sharpens the next round.
          </p>
        </InView>
      </div>

      <InView delay={0.12} y={26} className="mt-12" data-id="element-53" data-mp="18vdrx3negw0v">
        <figure className="rounded-[30px] bg-canvas2 p-4 sm:p-6" data-id="element-54" data-mp="18yrsq7gf0x67">
          <div className="grid items-stretch gap-4 sm:grid-cols-[22fr_auto_46fr_auto_32fr]" data-id="element-55" data-mp="1dx34wou6njrl">
            <div className="flex flex-col justify-center rounded-[20px] bg-paper p-5" data-id="element-56" data-mp="zxbko6d2p755">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#25D366]/15 text-[#128C4B]" data-id="element-57" data-mp="13y3ub0puxe1y">
                <MessageSquareTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="1rnoqwmexo9tp" />
              </span>
              <p className="mt-4 rounded-[14px] rounded-tl-[4px] bg-canvas px-3.5 py-3 text-[13px] leading-snug text-navy" data-id="element-59" data-mp="1wl84dk3t4ikl">
                Same diagnosis, different phenotype? 60 seconds of new OCT data →
              </p>
            </div>
            <Arrow data-id="element-60" data-mp="2am11mclhtrre" />
            <div className="grid grid-cols-3 gap-3 rounded-[20px] bg-paper p-4" data-id="element-61" data-mp="2aliu2jtdrr46">
              <MiniScreen data-id="element-62" data-mp="2fc93q98uag4o">
                <img src={heroOct.src} alt="" className="block h-[60%] w-full rounded-[6px] object-cover" data-id="element-63" data-mp="2fdizusw4te8o" />
                <p className="mt-2 text-[9px] font-semibold leading-tight text-navy" data-id="element-64" data-mp="2p76k2lm9lpuy">An OCT case</p>
              </MiniScreen>
              <MiniScreen data-id="element-65" data-mp="2l4ryhtr7obzz">
                <p className="text-[9px] font-semibold leading-tight text-navy" data-id="element-66" data-mp="2g7jdzmilbvvk">{introPoll.question}</p>
                <div className="mt-2 space-y-1" data-id="element-67" data-mp="2b8yn4dp8aojs">
                  {introPoll.options.map(o => <span key={o.id} className="block rounded-[4px] border border-line px-1.5 py-1 text-[8px] text-navy" data-id="element-68" data-mp="26a5asoloh3l7">
                      {o.label}
                    </span>)}
                </div>
              </MiniScreen>
              <MiniScreen data-id="element-69" data-mp="1xhto9dtoq0ai">
                <p className="text-[9px] font-semibold leading-tight text-navy" data-id="element-70" data-mp="1xexqbphu7bm2">Your peers</p>
                <div className="mt-2 space-y-1.5" data-id="element-71" data-mp="1sgdyj8gkb5ls">
                  {introPoll.options.map(o => <div key={o.id} className="h-1.5 overflow-hidden rounded-full bg-mist" data-id="element-72" data-mp="1nkyrazd287yc">
                      <div className="h-full rounded-full bg-blue" style={{
                    width: `${o.share}%`
                  }} data-id="element-73" data-mp="1imdnkpyln655" />
                    </div>)}
                </div>
              </MiniScreen>
            </div>
            <Arrow data-id="element-74" data-mp="1ieab5m6gvh9a" />
            <div className="flex flex-col justify-center rounded-[20px] bg-navy p-5 text-paper" data-id="element-75" data-mp="1idqvyd87b6yy">
              <span className="text-[10px] uppercase tracking-[0.2em] text-mint" data-id="element-76" data-mp="1ndwnzuiduvhk">Campaign report</span>
              <div className="mt-4 flex h-[90px] items-end gap-2" aria-hidden="true" data-id="element-77" data-mp="pq4ogtvuri6t">
                {[40, 62, 55, 80, 72, 90].map((h, i) => <span key={i} className="flex-1 rounded-t-[4px] bg-mint/80" style={{
                height: `${h}%`
              }} data-id="element-78" data-mp="uoz79vttl6qx" data-mpi={i} />)}
              </div>
              <p className="mt-3 text-[11px] text-paper/60" data-id="element-79" data-mp="14f0wws1tmx7y">Illustrative</p>
            </div>
          </div>

          <div className="mt-5 grid gap-4 sm:grid-cols-[22fr_46fr_32fr]" data-id="element-80" data-mp="6zwt4xye9w16">
            {campaignStages.map((stage, i) => <div key={stage.name} className="border-t border-navy/15 pt-3" data-id="element-81" data-mp="bwwwh13v0kol" data-mpi={i}>
                <span className="text-[10px] tabular-nums tracking-[0.2em] text-navy/40" data-id="element-82" data-mp="2dmlyodaeeqo3">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="ml-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-navy" data-id="element-83" data-mp="2nd6yg41t618l">{stage.name}</span>
                <p className="mt-1 text-[13px] leading-snug text-navy/60" data-id="element-84" data-mp="2ilymb093g1rq">{stage.detail}</p>
              </div>)}
          </div>

          <figcaption className="mt-5 flex justify-center" data-id="element-85" data-mp="2wcajveog6sq9">
            <span className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-[11.5px] text-paper" data-id="element-86" data-mp="2sd1ns35xqirj">
              <RefreshCwIcon className="h-3.5 w-3.5 text-mint" aria-hidden="true" data-id="element-87" data-mp="36aq91c3wzrx4" />
              Continuous loop — every answer sharpens the next hook and question
            </span>
          </figcaption>
        </figure>
      </InView>

      <div className="mt-14 grid gap-10 border-t border-navy/[0.12] pt-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-center lg:gap-16" data-id="element-88" data-mp="1c04i9a3mfdoy">
        <InView delay={0.18} data-id="element-89" data-mp="3inbu6ew042xi">
          <span className="text-[10px] uppercase tracking-[0.22em] text-navy/45" data-id="element-90" data-mp="3in2ebk4o7c5j">We don’t start from zero every time</span>
          <ul className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-91" data-mp="3nn7y6e4p7ud2">
            {reuseBlocks.map(block => <li key={block} className="rounded-[16px] bg-paper px-4 py-4 ring-1 ring-navy/[0.08]" data-id="element-92" data-mp="3dvalf2y1kuc8">
                <span className="block text-[12px] text-navy/45" data-id="element-93" data-mp="2zw2hxxuuj028">Reuse</span>
                <span className="mt-0.5 block font-display text-[18px] font-semibold leading-tight text-navy" data-id="element-94" data-mp="2zy5kfhd6qlnu">{block}</span>
              </li>)}
            <li className="col-span-2 rounded-[16px] border-2 border-dashed border-mint px-4 py-4 sm:col-span-1" data-id="element-95" data-mp="2pywtkxdm9n5p">
              <span className="block text-[12px] text-blue" data-id="element-96" data-mp="2ux8131gfvlkr">Build</span>
              <span className="mt-0.5 block font-display text-[18px] font-semibold leading-tight text-navy" data-id="element-97" data-mp="o605o9ylyq46">
                Only what’s missing
              </span>
            </li>
          </ul>
        </InView>

        <InView delay={0.24} data-id="element-98" data-mp="roz2u8sqb25x">
          <p className="font-display text-[28px] font-semibold leading-[1.1] tracking-[-0.02em] text-navy sm:text-[36px]" data-id="element-99" data-mp="rm34ijcyybgy">
            More frequent support and more trust — <span className="text-navy/45" data-id="element-100" data-mp="hr1hbt297jh0">at manageable cost.</span>
          </p>
        </InView>
      </div>

      <InView delay={0.28} data-id="element-101" data-mp="dpzd0xthch86">
        <div className="mt-10 rounded-[24px] bg-navy p-6 sm:p-8" data-id="element-102" data-mp="dqr9sbytcl01">
          <span className="text-[10px] uppercase tracking-[0.22em] text-mint" data-id="element-103" data-mp="1adcgr0e4jec8">Suggested next step</span>
          <ol className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-104" data-mp="15g475o71kiml">
            {nextSteps.map((step, i) => <li key={step.verb} className="border-t border-paper/15 pt-4" data-id="element-105" data-mp="10mrixf69ydud" data-mpi={i}>
                <span className="text-[10px] tabular-nums text-paper/40" data-id="element-106" data-mp="wmr59wr026od">{String(i + 1).padStart(2, '0')}</span>
                <p className="mt-1 font-display text-[18px] font-medium leading-snug text-paper" data-id="element-107" data-mp="1t6gbyq6zpz8y">
                  <span className="font-semibold text-mint" data-id="element-108" data-mp="1od5ehfo2iutp">{step.verb}</span> {step.text}
                </p>
              </li>)}
          </ol>
        </div>
      </InView>

      <p className="mt-12 text-[10px] uppercase tracking-[0.18em] text-navy/25" data-id="element-109" data-mp="3c12qt4kl2kjy">{deckMeta.footer}</p>
    </Slide>;
}
function Arrow() {
  return <span aria-hidden="true" className="hidden items-center text-navy/35 sm:flex" data-id="element-110" data-mp="3l0y1776bebix">
      <ArrowRightIcon className="h-4 w-4" data-id="element-111" data-mp="3kyldsehsf8yh" />
    </span>;
}
function MiniScreen({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex aspect-[9/16] flex-col overflow-hidden rounded-[12px] border-[3px] border-[#0A1622] bg-paper p-2" data-id="element-112" data-mp="3uyc9gji33u05">
      {children}
    </div>;
}